// extracted by mini-css-extract-plugin
module.exports = {"offSeasonDiv":"OffSeasonComponent_offSeasonDiv__DWLPG"};